export default __webpack_public_path__ + "static/media/audio-effect.2b7450e6.png";